<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Monitoramento de Frota</div>
  <!--  @if (checkPermission('criar')) {-->
  <!--  }-->
</div>
<div>
  <app-monitoring-search (response)="listSearch($event)" (loadingList)="loading"></app-monitoring-search>
</div>

<div>
  <div class="mt-4">
    <!--    @if (checkPermission('pesquisar-paginado')) {-->
    <!--    <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
    <!--    <form-client-search-->
    <!--      [search]="inputSearch"-->
    <!--      [listSearch]="listSearch"-->
    <!--      (responseSearch)="search($event)"-->
    <!--    />-->
    <!--    }-->
    <div>
      @if (!loading) {
      @if (itemsList.length > 0) {
      <div class="tab-overflow overflow-auto w-[100%]">
        <table-list-monitoring [dataSource]="itemsList" [columns]="columns" (viewItem)="viewItem($event)"
          (additionalOccurrenceItem)="addOccurrenceItem($event)" sticky />
      </div>

      } @else {
      <div>
        <h3 class="text-center">Nenhum registro encontrado.</h3>
      </div>
      }
      } @else {

      <mat-progress-bar mode="indeterminate"></mat-progress-bar>

      }
      <mat-paginator [hidden]="itemsList.length == 0 || loading" [length]="numberRows" [pageSize]="rows"
        [pageIndex]="page - 1" [pageSizeOptions]="[5, 10, 20, 30]" (page)="onPageEvent($event)">
      </mat-paginator>
    </div>
  </div>
</div>